import { Modality } from '../../interfaces/api/modality';
import { getModalities } from '../../api/modalities';

export async function fetchModalities(): Promise<Modality[]> {
	try {
		return await getModalities();
	} catch (error) {
		throw error;
	}
}
